import ScalarIconArrowUp_vue_vue_type_script_setup_true_lang_default from "./ScalarIconArrowUp.vue.script.js";
//#region src/components/ScalarIconArrowUp.vue
var ScalarIconArrowUp_default = ScalarIconArrowUp_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconArrowUp_default as default };

//# sourceMappingURL=ScalarIconArrowUp.js.map